<template>
  <v-select
    id="loginType"
    v-model="selectedLoginType"
    class="login-type"
    :items="loginOptions"
  ></v-select>
</template>

<script>
// export default {
//   props: {
//     landingPage: {
//       default: false,
//       type: Boolean,
//       required: false
//     }
//   },
//   computed: {
//     version() {
//       return this.$store.state.profile.appversion
//     }
//   },
//   watch: {
//     // version() {
//     //   this.filterCountryCodes()
//     // }
//   },
//   // created() {
//   //   this.filterCountryCodes()
//   // },
//   methods: {
//     // filterCountryCodes() {
//     //   if (this.version && this.version.projectCode !== 'bd') {
//     //     const ccData = this.countryCodes.filter(function (data) {
//     //       return (
//     //         data.name === 'India' ||
//     //         data.name === 'United Arab Emirates' ||
//     //         data.name === 'Bangladesh' ||
//     //         data.name === 'Australia' ||
//     //         data.name === 'Canada'
//     //       )
//     //     })
//     //     this.countryCodes = []
//     //     this.countryCodes = ccData
//     //   }
//     // }
//   }
// }

export default {
  data() {
    return {
      selectedLoginType: 'username', // Default to username
      username: '',
      mobile: '',
      loginOptions: [
        { label: 'Username', value: 'username' },
        { label: 'Mobile Number', value: 'mobile' }
      ]
    }
  }
}
</script>
